import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as o}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const l=t("apaylo",o`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM4.32459 12C4.32459 16.239 7.76099 19.6754 12 19.6754C16.239 19.6754 19.6754 16.239 19.6754 12C19.6754 7.76099 16.239 4.32459 12 4.32459C7.76099 4.32459 4.32459 7.76099 4.32459 12Z"
                fill="url(#paint0_angular_10936_57478)" />
            <circle
                cx="18.1074"
                cy="19.7339"
                r="2.15869"
                fill="#BFD731" />
            <defs>
                <radialGradient
                    id="paint0_angular_10936_57478"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(11.4729 12.5359) rotate(46.7663) scale(10.5747)">
                    <stop stop-color="#C3D72E" />
                    <stop
                        offset="0.5"
                        stop-color="#19BA94" />
                    <stop
                        offset="0.75"
                        stop-color="#0EA29A" />
                    <stop
                        offset="0.875"
                        stop-color="#135D90" />
                    <stop
                        offset="1"
                        stop-color="#16498F" />
                </radialGradient>
            </defs>
        </svg>
    `);export{l as Apaylo};
